import type { Point } from './types';

export function fitCanvasToVideo(canvas: HTMLCanvasElement, video: HTMLVideoElement) {
  const w = video.clientWidth;
  const h = video.clientHeight;
  const dpr = window.devicePixelRatio || 1;
  canvas.width = Math.round(w * dpr);
  canvas.height = Math.round(h * dpr);
  canvas.style.width = `${w}px`;
  canvas.style.height = `${h}px`;
}

export function drawCornersOverlay(
  canvas: HTMLCanvasElement,
  video: HTMLVideoElement,
  corners: Point[] | null,
) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  if (!corners || corners.length !== 4) return;
  const vw = video.videoWidth;
  const vh = video.videoHeight;
  if (!vw || !vh) return;
  const detectLong = 720;
  const detectShort = Math.min(vw, vh) * (detectLong / Math.max(vw, vh));
  const detectW = vw >= vh ? detectLong : detectShort;
  const detectH = vw >= vh ? detectShort : detectLong;
  const sx = canvas.width / detectW;
  const sy = canvas.height / detectH;
  ctx.strokeStyle = '#33ff88';
  ctx.lineWidth = Math.max(2, canvas.width / 200);
  ctx.beginPath();
  for (let i = 0; i < 4; i++) {
    const p = corners[i];
    const x = p.x * sx;
    const y = p.y * sy;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  ctx.stroke();
}

export function paintResult(canvas: HTMLCanvasElement, bitmap: ImageBitmap) {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const ar = bitmap.width / bitmap.height;
  const cw = canvas.clientWidth;
  const ch = canvas.clientHeight;
  let dw = cw;
  let dh = cw / ar;
  if (dh > ch) {
    dh = ch;
    dw = ch * ar;
  }
  const dpr = window.devicePixelRatio || 1;
  canvas.width = Math.round(dw * dpr);
  canvas.height = Math.round(dh * dpr);
  canvas.style.width = `${dw}px`;
  canvas.style.height = `${dh}px`;
  ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
}
